
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { EventStatus } from '@/services/eventService';
import { cn } from '@/lib/utils';
import {
  AlertCircle,
  Archive,
  CheckCircle2,
  Clock,
  FileEdit
} from 'lucide-react';

import { useAuth } from '@/contexts/AuthContext';
import { UserRoles } from '@/contexts/auth/enums';


const statusConfig = {
  [EventStatus.DRAFT]: {
    label: 'Vázlat',
    color: 'bg-slate-100 text-slate-700 border-slate-200',
    icon: FileEdit
  },
  [EventStatus.PUBLISHED]: {
    label: 'Közzétéve',
    color: 'bg-green-100 text-green-700 border-green-200',
    icon: CheckCircle2
  },
  [EventStatus.CANCELLED]: {
    label: 'Törölve',
    color: 'bg-red-100 text-red-700 border-red-200',
    icon: AlertCircle
  },
  [EventStatus.ARCHIVED]: {
    label: 'Archiválva',
    color: 'bg-amber-100 text-amber-700 border-amber-200',
    icon: Archive
  },
  [EventStatus.POSTPONED]: {
    label: 'Elhalasztva',
    color: 'bg-blue-100 text-blue-700 border-blue-200',
    icon: Clock
  }
};

interface StatusBadgeProps {
  status: EventStatus;
  showIcon?: boolean;
  className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  showIcon = true,
  className
}) => {

  const { user, isAuthenticated } = useAuth();


  if (
    !isAuthenticated ||
    !user?.roles.includes(UserRoles.ORGANIZER) &&
    !user?.roles.includes(UserRoles.ADMIN)
  ) {
    return null;
  }


  const config = statusConfig[status] || statusConfig[EventStatus.DRAFT];
  const Icon = config.icon;

  return (
    <Badge
      variant="outline"
      className={cn(
        'font-medium rounded-full px-2 py-1',
        config.color,
        className
      )}
    >
      {showIcon && <Icon className="w-3.5 h-3.5 mr-1" />}
      {config.label}
    </Badge>
  );
};

export default StatusBadge;
